import React from 'react';
import { Container } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import { NavMenu } from './NavMenu';
import SideRailAds from './ads/SideRailAds';
import BannerAd from './ads/BannerAd';

// Pages that are cross-origin isolated (COEP: require-corp) for the Stockfish engine.
// Third-party ads are incompatible with require-corp, so we exclude these paths.
// Keep in sync with CrossOriginIsolationMiddleware "usesStockfish" paths.
const AD_EXCLUDED_PATHS = ['/games/gamebyid', '/analysis', '/engine'];

function isAdExcludedPath(pathname) {
    const path = (pathname || '').toLowerCase();
    return AD_EXCLUDED_PATHS.some(p => path.includes(p));
}

function Layout(props) {
    const showAds = !isAdExcludedPath(props.location?.pathname);

    return (
        <div>
            <NavMenu />
            {showAds && <SideRailAds />}
            <Container>
                {showAds && <BannerAd />}
                {props.children}
            </Container>
        </div>
    );
}

const LayoutWithRouter = withRouter(Layout);
export { LayoutWithRouter as Layout };

